import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { dataModel } from '../../../models/data.model';
import { CommunicationService } from '../../../common/services/Communication.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.sass']
})
export class LoginPageComponent implements OnInit {
  @Input() data: dataModel;
  constructor(private route: ActivatedRoute, communicationService: CommunicationService) {
    this.data = communicationService.data;
   }

  ngOnInit() {
  }
}
